function printUrl(){
  $('.product__accordion-content .print-link').on('click', function(e) {
    e.preventDefault();
    const $this = $(this);
    const winLocation = window.location;
    let linkHref = winLocation.origin + $this.attr('href');
    if (winLocation.search) {
      linkHref = linkHref +  winLocation.search.replace('?', '&');
    }
    window.location.href = linkHref;
  })
}

export default printUrl();



// WEBPACK FOOTER //
// ../markup/assets/js/product-print.js